
import React, {useContext} from "react";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import mrTranslations from "./translations/mr.json";
import { LanguageContext } from "./LanguageContext";
import  "./ConfirmPopup.css";

function ConfirmPopup({ handleCloseDeleteSuccessAlert }) {
  const { selectedLanguage } = useContext(LanguageContext);
  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hin: hinTranslations,
    mr: mrTranslations,
  };

  const translatedText = (key) => translations[selectedLanguage][key] || key;

  return (
  <div className="confirm-popup">
            <div className="cofirm-popup-content">
            <p>{translatedText("confirm_delete_message")}</p>
                <button className="btn3" onClick={handleCloseDeleteSuccessAlert}>
                Ok
                </button>
            </div>
            </div> 
  );
}

export default ConfirmPopup;
